import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Replace with your Stripe publishable key
const stripePromise = loadStripe(
  "pk_test_51NLbbpHoG5eJHlgiMMqOMMhGPlk8w2UsxGBzvyOBF0X1LlwBjHjRaZuazz7reLylPn4YPXqMNqpt5x3m5gIYL64P007s91KWfn"
);

const StripeProvider = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
